import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useStoreSelector } from "../../../../../hooks/StoreHooks";
import { Formik, Form } from "formik";
import { FormRender } from "../../../../render/formRender";
import Pergola from "./components/pergola-draw/Pergola";

export const MainPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { pergolaConfigurationBuilder } = useStoreSelector((store) => store);

  // Stato per forzare il rimontaggio del componente Pergola
  const [renderKey, setRenderKey] = useState(1);

  useEffect(() => {
    if (!id || isNaN(Number(id))) {
      navigate("/configurations");
      return;
    }
    const timer = setTimeout(() => {
      setRenderKey(2);
    }, 500);

    return () => clearTimeout(timer);
  }, [id, navigate]);

  const initialValues = {
    dimensions: {
      width: "",
      height: "",
      depth: ""
    },
    aspect: {
      color: "",
      material: ""
    },
    illumination: {
      hasLed: false,
      intensity: 0
    },
  };

  const handleSubmit = (values: typeof initialValues) => {
  };

  const screenshotFnRef = useRef<(() => Promise<void>) | null>(null);

  return (
    <div className="row m-0 h-full">
      <div className="col-xl-7 p-0" style={{position: "relative"}}>
        <Pergola
          key={renderKey}   // ← Questo forza il completo smontaggio + rimontaggio
          onScreenshotReady={(fn) => {
            screenshotFnRef.current = fn;
          }}
        />
      </div>

     <div className="col-xl-5 p-0 quote-summary" style={{ overflowY: window.innerWidth < window.innerHeight ? undefined : "auto", height: "100%", borderLeft: "solid 1px #ccc" }}>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ values }) => (
            <Form style={{ width: "100%", padding: "1rem" }}>
              <FormRender
                takeScreenshot={async () => {
                  if (!screenshotFnRef.current) return;
                  await screenshotFnRef.current();
                }}
              />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};